import { Box, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import PageTitle from "components/common/PageTitle";
import PreferredEmailBanner from "components/common/PreferredEmailBanner";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { DISPLAY_TYPE } from "utils/CommonConstants";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import NumberSet from "./NumberSet";
import Overview from "./Overview";

const MyDashboard = () => {
  const { isMobileScreen } = useContext(ThemeContext);
  const { isAdmin, isAbovePropertyUser } = useAppSelector((state) => state.app);
  const cardsSnapshot: any = useAppSelector((state) => state?.Dashboard.dashboardReport?.CARDS_SNAPSHOT[0]);
  const plansSnapshot: any = useAppSelector((state) => state?.Dashboard.dashboardReport?.PLANS_SNAPSHOT[0]);
  const loggedInUserDetails = getLoggedInUserDetails();

  return (
    <Box paddingRight={isMobileScreen ? "0" : "24px"} sx={{ marginTop: "32px", width: "100%" }}>
      {!isAdmin && !isAbovePropertyUser && <PageTitle label="My Dashboard" />}
      {loggedInUserDetails &&
        Object.keys(loggedInUserDetails).length !== 0 &&
        !loggedInUserDetails?.preferredEmail &&
        !isAdmin &&
        !isAbovePropertyUser && <PreferredEmailBanner />}

      <Grid container gap={"8px"}>
        <Grid item xs={12} md={true}>
          {plansSnapshot && <NumberSet title={"Plans"} snapShot={plansSnapshot} />}
        </Grid>
        <Grid item xs={12} md={true}>
          {cardsSnapshot && <NumberSet title={"Actions"} snapShot={cardsSnapshot} />}
        </Grid>
      </Grid>
      <Grid container marginY={"32px"} gap={"16px"}>
        <Grid item xs={12} md={7}>
          <Overview
            type={isAdmin || isAbovePropertyUser ? DISPLAY_TYPE.userDashboardMyPlans : DISPLAY_TYPE.myPlansOverview}
          />
        </Grid>
        <Grid item xs={12} md={true}>
          <Overview
            type={isAdmin || isAbovePropertyUser ? DISPLAY_TYPE.userDashboardHighlights : DISPLAY_TYPE.highlights}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MyDashboard;
